import { RequestItemModel } from '../../../modules/requests/requestsModel'
import { ASSURANCE_CATEGORY } from '../../../modules/requests/list/RequestCard'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { propertyType } from '../../../enums/contractsEnum'

export const isNouveauLocataire = (contracts: ContractsModel[]) => {
	for (const contract of contracts) {
		if (contract.dateEffet) {
			let date = new Date(contract.dateEffet)
			if (hasParkingAndApartement(contracts)) {
				if (contract.type === propertyType.apartment && new Date(date.setMonth(date.getMonth() + 1)) > new Date()) {
					return true
				}
			} else {
				if (new Date(date.setMonth(date.getMonth() + 1)) > new Date()) {
					return true
				}
			}
		}
	}
	return false
}

const hasParkingAndApartement = (contracts: ContractsModel[]) => {
	return contracts.filter((contract) => contract.type === propertyType.apartment).length > 0 && contracts.filter((contract) => contract.type !== propertyType.apartment).length > 0
}

export const canDisplayAssuranceAlert = (requests: RequestItemModel[]) => {
	return !hasOpenAssuranceRequest(requests)
}

//Check if there is no request in progress for insurance
const hasOpenAssuranceRequest = (requests: RequestItemModel[]) => {
	return requests.filter(request => request.category === ASSURANCE_CATEGORY && request.actif).length > 0
}
